export default __webpack_public_path__ + "static/media/cdsl.6cbf6881.png";